module.exports = {
  entry: './src/apps/product-explorer/index.tsx',
  shortcode: 'product-explorer',
  title: 'Product Explorer',
  status: 'stable',
  description:
    'JavaScript widget that allows users to explore various IBM products on offer.',
  preview: {
    url: `${process.env.PUBLIC_URL}/storybook/iframe.html?id=widgets-product-explorer-components--default&viewMode=story`,
  },
  useExternalPeerDependencies: ['react', 'react-dom', 'react-intl'],
  settingsSchema: {
    type: 'object',
    additionalProperties: false,
    properties: {
      fields: {
        type: 'object',
        properties: {
          'link-type': {
            type: 'string',
            title: 'Link Type',
            enum: ['product', 'pricing'],
          },
          theme: {
            type: 'string',
            title: 'Carbon Theme',
            description:
              "Force the palette of the widget to 'White' or 'Gray 100'. Otherwise the CMS should provide a value based on the page context.",
            default: 'GRAY_100',
            examples: ['WHITE'],
            enum: ['null', 'WHITE', 'GRAY_100'],
          },
        },
      },
    },
  },
  uiFormSchema: {
    'link-type': {
      'ui:widget': 'radios',
      'ui:help':
        'Selecting "Product" will render links to the product page. Selecting "Pricing" will render links to the product\'s pricing page. If a product has no pricing url the product will not be shown in the widget.',
      'ui:enum': {
        labels: {
          mappings: {
            product: 'Product',
            pricing: 'Pricing',
          },
        },
      },
    },
  },
  additionalCustomProperties: {
    webSegmentPaths: ['/cloud'],
    availableTranslations: [
      'de',
      'en',
      'es',
      'esla',
      'fr',
      'it',
      'ja',
      'ko',
      'pt',
      'zh-cn',
    ],
    uiFormSchema: {
      theme: {
        'ui:widget': 'select',
        'ui:enum': {
          labels: {
            mappings: {
              null: '-Derive value from page-',
              WHITE: 'White',
              GRAY_100: 'Gray 100',
            },
          },
        },
      },
    },
  },
};
